import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-no-elements-template',
	templateUrl: './no-elements-template.component.html',
	styleUrls: ['./no-elements-template.component.scss']
})
export class NoElementsTemplateComponent {

	@Input() img_src! : string;
	@Input() caption! : string;
	@Input() route? : string;
	@Input() linkCaption? : string;
	@Input() wrapper_classes : string = "";

}
